import { render, staticRenderFns } from "./Importing.vue?vue&type=template&id=14b8b9aa&scoped=true&"
import script from "./Importing.vue?vue&type=script&lang=ts&"
export * from "./Importing.vue?vue&type=script&lang=ts&"
import style0 from "./Importing.vue?vue&type=style&index=0&id=14b8b9aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b8b9aa",
  null
  
)

export default component.exports